/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import {
    object, func, number, shape, string, bool,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';

import EventDispatcher from '../../../state/reducers/EventDispatcher';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import DesktopChangeName from './DesktopChangeName';
import DesktopChangeEmail from './DesktopChangeEmail';
import DesktopChangePassword from './DesktopChangePassword';

class DesktopProfileAndPassword extends Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = () => {
        const { fetchUserProfile } = this.props;
        fetchUserProfile();
    };

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    changeNameTemplate = (userProfile) => (
        <>
            <Grid className="block" item xs={12}>
                <div className="blockHeader">Name</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom" item xs={9}>
                <DesktopChangeName firstName={userProfile.firstName} lastName={userProfile.lastName} />
            </Grid>
        </>
    );

    changeEmailTemplate = () => (
        <>
            <Grid className="block" item xs={12}>
                <div className="blockHeader">Email Address</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom" item xs={9}>
                <DesktopChangeEmail />
            </Grid>
        </>
    );

    changePasswordTemplate = () => (
        <>
            <Grid className="block" item xs={12}>
                <div className="blockHeader">Account Password</div>
            </Grid>
            <Grid className="blockContent hasForm no-margin-bottom" item xs={9}>
                <DesktopChangePassword />
            </Grid>
        </>
    );

    render() {
        const {
            userProfile,
            featureFlags,
            handleSubmitProfileAndPassword,
        } = this.props;
        // console.log(userProfile);
        return (
            <Grid className="container" container>
                <AccountLeftMenu
                    userProfile={userProfile}
                    featureFlags={featureFlags}
                />
                <Grid item xs={10} style={{ padding: '40px 11px 0 43px' }}>
                    <div className="position-relative">
                        <h2 className="float-left">Profile &amp; Password</h2>
                        <span className="float-right small gray-color">* Required Field</span>
                    </div>
                    <Grid className="shadowContentGrid contentGrid" container item xs={12}>
                        {this.changeNameTemplate(userProfile)}
                        {this.changeEmailTemplate()}
                        {this.changePasswordTemplate()}
                    </Grid>
                    <div className="margin-top-2x">
                        <Button
                            onClick={() => handleSubmitProfileAndPassword()}
                            variant="contained"
                            color="primary"
                            data-test="my-account-update-profile"
                            className=""
                        >
                            Save
                        </Button>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

DesktopProfileAndPassword.defaultProps = {
    userProfile: {},
    featureFlags: {},
};

DesktopProfileAndPassword.propTypes = {
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
        XAtt4: string,
        XAtt5: string,
    }),
    fetchUserProfile: func.isRequired,
    handleSubmitProfileAndPassword: func.isRequired,
    featureFlags: object,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state.account ? state.account : state;
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        userProfile: newState.userProfile,
        featureFlags,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchUserProfile: () => dispatch(EventDispatcher.fetchUserProfile()),
    handleSubmitProfileAndPassword: () => dispatch(EventDispatcher.handleSubmitProfileAndPassword()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter((DesktopProfileAndPassword)));
